import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Counter, WhyUs, ManifestLetter, Services, News, Partners } from '../../../sections';
import { useTranslation } from 'react-i18next';
import { titles } from '../../../constants';


const AboutUs = () => {

  const t = useTranslation().t;

  return (
    <>

      {/* Page title */}
      <PageTitle title={t(titles.aboutUs)} page={t(titles.aboutUs)} />

      <section className='about-us'>

          <About />    {/* About section */}
          <WhyUs />    {/* Why Us section */}
          <News />     {/* Process section */}
          <Counter />  {/* Counter section */}
          <ManifestLetter/>
          <Services /> {/* Services section */}
          <Partners /> {/* Clients Section */}

      </section>

    </>
  );
}

export default AboutUs;